import axios from 'axios'
import '@/assets/js/public/UrlConfig'
import {getToken, removeToken} from './auth'
import cookie from '@assets/js/public/Cookie'
import {Toast} from 'vant';
import router from '../router'

// create an axios instance
const localhostBaseURLStr = global.gatewayLocalhostBaseApiUrl
const baseUrl = global.gatewayBaseUrl


const service = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? baseUrl : localhostBaseURLStr,
    timeout: 50000,
    headers: {
        'Cache-Control': 'no-cache'
    }
})

// request interceptor
service.interceptors.request.use(config => {
    // Do something before request is sent
    if (getToken('access_token')) {
        config.headers.Authorization = `Bearer ${getToken('access_token')}`
        // config.headers.Accept = 'text/html,application/xhtml+xml,application/xml'
    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => {
        return response
    },
    error => {
        // console.log(error.status);
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    cookie.removeUser()
                    removeToken('access_token')
                    if (router.currentRoute.fullPath !== '/') {
                        Toast({
                            message: '登录过期，请重新登录',
                            duration: 1000,
                            forbidClick: true
                        });
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    Toast({
                        message: '登录过期，请重新登录',
                        duration: 1000,
                        forbidClick: true
                    });
                    // 清除token和用户信息
                    cookie.removeUser()
                    removeToken('access_token')
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;

                // 404请求不存在
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    Toast({
                        message: '出错啦',
                        duration: 1500,
                        forbidClick: true
                    });
            }
        }
        return Promise.reject(error)
    })

export default service
